const createCookie = () => {

    const name = "quiz_user_id";
    const existing = document.cookie
        .split("; ")
        .find(row => row.startsWith(name + "="))
        ?.split("=")[1];

    if (existing) return existing;

    const newID = "user_" + Math.random().toString(36).slice(2, 9);

    document.cookie = `${name}=${newID}; max-age=${2*60*60}; path=/`;

    return newID;

}; export default createCookie;